export default "__VITE_ASSET__qI7bfFze__"